<template>
  <el-dialog title="选择角色" width="30%" :visible="show" @opened="setSelect" :before-close="close">
    <div class="list-table" style="height: 300px">
      <new-table :selectable="selectable" @selection-change="handleSelectionChange" ref="selectRole" :isSelect="true"
                 :isShowNumber="false" firstType='selection' :data="listData" :columns="columns"
                 :pages="null"></new-table>
    </div>
    <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save">确 定</el-button>
            <el-button @click="close">取 消</el-button>
        </span>
  </el-dialog>
</template>
<script>
  import orgApi from "@/apis/org.js"
  import newTable from "@/components/new-table.vue";
  import CacheService from "@/service/catch";

  export default {
    name: "role-list",
    components: {newTable},
    props: {
      show: {default: false},
      selectedUser: {
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
        listData: [],
        columns: [{label: "角色名称", prop: "roleName"}],
        multipleSelection: [],
        returnData: {},
        getRows: [],
      }
    },
    computed: {
      selectedRoles() {
        return this.selectedUser ? this.selectedUser.roleList : []
      }
    },
    methods: {
      async setSelect() {
        this.returnData = this.selectedUser;
        await this.getData();
        if (this.selectedRoles.length > 0) {
          let rows = this.listData.filter(role => this.selectedRoles.find(_role => _role.id == role.id));
          this.getRows = rows;
          this.toggleSelection(rows)
        }
      },
      async toggleSelection(rows) {
        if (rows && rows.length) {
          rows.forEach(row => {
            this.$refs.selectRole.toggleRowSelection(row, true)
            if (this.returnData && this.returnData.isPlatAdmin == 1) {
              if (row.roleName === '管理员') {
                row.typeName = "delivery";
                row.deliveryType = 1;
              }
            }
          });
        } else {
          if (this.getRows) {
            this.getRows.forEach((item) => {
              item.typeName = "delivery1";
              item.deliveryType = 0;
            })
          }
          this.$refs.selectRole.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      handleRowClick(row) {
        this.$refs.selectRole.toggleRowSelection(row)
      },
      async getData() {
        const res = await orgApi.getCompRoleList()
        this.listData = res;
      },
      save() {
        let roles = this.multipleSelection.map(row => row.id)
        let data = {userId: this.selectedUser.id, roleId: roles}
        orgApi.addUserRole(data).then(res => {
          if (res) {
            this.$message.success("设置成功");
            this.$emit("success", true)
            this.returnData.roleList = this.multipleSelection.map(row => {
              return {id: row.id, roleName: row.roleName}
            })
            this.close()
          }
        })

      },
      close() {
        this.toggleSelection()
        this.$emit("update:show", false)
      },
      selectable(row) {
        if (row.typeName == "delivery") {
          if (row.deliveryType == 1) {
            return false;
          }
        }
        if ( row.id == CacheService.get("user").userID) {
          return false
        }
        return true;
      },
    }
  }
</script>

